import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';

import { ConfigProvider } from 'antd';
import en from 'antd/lib/locale-provider/en_US';

import App from './App';
import * as serviceWorker from './serviceWorker';
import Messages from './theme/messages';

import { Provider } from 'react-redux';
import store from './store';

// if (window.fetch) {
//   // Check whether ES6 is supported in Modern Browsers
//   import("./App").then(function (module) {
//     module.default();
//   });
// } else {
//   // For legacy or old browsers
//   import("./polyfills").then(() => {
//     import("./App").then(function (module) {
//       module.default();
//     });
//   });
// }

ReactDOM.render(
  <ConfigProvider locale={en}>
    <Provider store={store}>
      <App />
      <Messages />
    </Provider>
  </ConfigProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
